import { httpV1 as http } from '@/services/api';

export function fromApiPayload(record) {
  return {
    id: record.id,
    promoterId: record.promoter_id,
    promoterName: record.promoter_name,
    startsAt: record.start_at,
    endsAt: record.end_at,
    channel: record.channel,
    reason: record.reason,
    status: record.status,
    summary: record.notes ?? null,
    agreedAction: record.agreed_action ?? null,
    nextActionDate: record.next_action_date ?? null,
    internalAction: record.internal_action ?? null,
  };
}

export function toCreatePayload(booking) {
  return {
    promoter_id: booking.promoterId,
    channel: booking.channel,
    reason: booking.reason,
    start_at: booking.startsAt,
    end_at: booking.endsAt,
  };
}

export function toCompletePayload(realization) {
  return {
    notes: realization.summary,
    agreed_action: realization.agreedAction,
    next_action_date: realization.nextActionDate ?? null,
    internal_action: realization.internalAction ?? null,
  };
}

export async function listBookingsByDate(date) {
  return http
    .get('/contact-schedules', { params: { date } })
    .then(({ data }) => (data?.data ?? []).map(fromApiPayload));
}

export async function createBooking(booking) {
  return http
    .post('/contact-schedules', toCreatePayload(booking))
    .then(({ data }) => fromApiPayload(data.data));
}

export async function realizeBooking(id, realization) {
  return http
    .put(`/contact-schedules/${id}/complete`, toCompletePayload(realization))
    .then(({ data }) => fromApiPayload(data.data));
}

export async function deleteBooking(id) {
  return http.delete(`/contact-schedules/${id}`);
}
